import { useState, useEffect } from "react";

import Pagination from "rc-pagination";

import useAxios from "services/useAxios.tsx";
import { pathMaker } from "utils/helperFunctions";
import Loader from "utils/Loader";

export default function DownloadProduct() {
  const { execute: getProductListApi } = useAxios("factor/productReport");

  const [productList, setProductList] = useState([]);
  const [pagination, setPagination] = useState({
    page: 1,
    count: 40,
    total: 0,
  });
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    getProductListApi({
      download: true,
      page: pagination?.page,
      count: pagination?.count,
    }).then((result) => {
      setProductList(result?.product);
      setPagination((prev) => ({ ...prev, total: result?.total }));
      setIsLoading(false);
    });
  }, [pagination?.page]);
  return isLoading ? (
    <div
      className="w-100 d-flex align-items-center justify-content-center"
      style={{ height: "50vh" }}
    >
      <Loader width={40} />
    </div>
  ) : (
    <div className="m-2 d-flex flex-wrap font-14-500">
      {productList?.map((productValue) => (
        <div className="col-6 pd-x-4 p-1">
          <div className="d-flex" style={{ border: "1px solid" }}>
            <div
              className="flex-grow-1 text-center"
              style={{ maxWidth: "80px" }}
            >
              <img
                src={pathMaker(productValue?.file?.[0]?.url)}
                style={{ height: "100px", width: "100%", objectFit: "cover" }}
              />
            </div>
            <div className="d-flex flex-column text-center">
              <div
                className="title font-12-700 py-1  border-bottom"
                style={{ height: 30, width: 90 }}
              >
                شناسه محصول
              </div>
              <div className="value flex-grow-1">{productValue?.id}</div>
            </div>
            <div className="flex-grow-1 d-flex flex-column text-center">
              <div
                className="title font-12-700 py-1  border-bottom border-right border-left"
                style={{ height: 30 }}
              >
                نام محصول
              </div>
              <div className="value flex-grow-1">{productValue?.title}</div>
            </div>
            <div className=" d-flex flex-column text-center">
              <div
                className="title font-12-700 py-1  border-bottom"
                style={{ height: 30, width: 90 }}
              >
                موجودی فعلی
              </div>
              <div className="value flex-grow-1">
                {productValue?.product_price?.reduce((total, sum) => {
                  return total + parseInt(sum?.inventory);
                }, 0)}
              </div>
            </div>
          </div>
          {/* <Table responsive bordered striped>
            <thead>
              <tr className="fw-bold">
                <td style={{ width: 60 }}></td>
                <td style={{ width: 100 }}>شناسه محصول</td>
                <td style={{ width: 100 }}>نام محصول</td>
                <td style={{ width: 100 }}>موجودی فعلی</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="">
                  <img
                    src={pathMaker(productValue?.file?.[0]?.url)}
                    style={{ width: "100px" }}
                  />
                </td>
                <td className="">{productValue?.id}</td>
                <td className="">{productValue?.title}</td>
                <td className=""></td>
              </tr>
            </tbody>
          </Table> */}
        </div>
      ))}
      <div className="d-flex justify-content-center mt-4 no-print col-12">
        <div>
          <Pagination
            className="px-1"
            total={pagination?.total}
            pageSize={pagination?.count}
            current={pagination?.page}
            onChange={(newPage) => {
              setPagination((prev) => ({ ...prev, page: newPage }));
            }}
          />
        </div>
      </div>
    </div>
  );
}
